import { render, staticRenderFns } from "./newClasses.vue?vue&type=template&id=69aa7971&scoped=true&"
import script from "./newClasses.vue?vue&type=script&lang=js&"
export * from "./newClasses.vue?vue&type=script&lang=js&"
import style0 from "./newClasses.vue?vue&type=style&index=0&id=69aa7971&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69aa7971",
  null
  
)

export default component.exports